import { useTranslation } from 'react-i18next'

const CollapseHeader = () => {
  const { t } = useTranslation()
  return <div className="collapse-rules-header">{t('LABEL_BUSINESS_RULES')}</div>
}

export default CollapseHeader
